<template>
  <div class="bottom-content">
    <v-btn block color="primary" tile :to="{ name: 'notifications' }" @click="$emit('close')">
      VIEW ALL NOTIFICATIONS
    </v-btn>
<!--    <router-link :to="{ name: 'notifications' }" class="caption" @click.native="$emit('close')">-->
<!--      VIEW ALL NOTIFICATIONS-->
<!--    </router-link>-->
  </div>
</template>

<script>
export default {
  name: 'ViewAllNotifications'
}
</script>

<style lang="scss" scoped>
.bottom-content {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: #E4E4E4;
}
</style>
